<template>
    <div  >
        <div style="width:100%; display:flex; background:#fff;line-height:35px;height:35px;margin-top:0px;  border-bottom:2px solid #389">
            <el-select v-model="selparam"  placeholder="请选择列名" filterable size="small" style="width:130px; ">
                <span v-for="item in tabArr" :key='item.key'>
                    <el-option v-if="item.thide=='N'" :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-input clearable ref="refinput" placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="txtparam" size="small" style="width:310px;height:30px ">
                <el-select v-model="oper" slot="prepend" size="small" style="width:105px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small"  slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
            </el-input>   
            <el-select v-model="selparam2"  placeholder="请选择列名" filterable size="small" style="width:130px; ">
                <span v-for="item in tabArr" :key='item.key'>
                    <el-option v-if="item.thide=='N'" :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select> 
            <el-input clearable placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="txtparam2" size="small" style="width:310px;height:30px ">
                <el-select v-model="oper2" slot="prepend" size="small" style="width:100px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small"  slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
            </el-input>
            <el-select v-model="selparam3"  placeholder="请选择列名" filterable size="small" style="width:130px; ">
                <span v-for="item in tabArr" :key='item.key'>
                    <el-option v-if="item.thide=='N'" :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-input clearable placeholder="请输入查询值" @keyup.enter.native="qryTabData" v-model="txtparam3" size="small" style="width:310px;height:30px ">
                <el-select v-model="oper3" slot="prepend" size="small" style="width:100px;  ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                        <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </span>
                </el-select>
                <el-button size="small"  slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
            </el-input>
            <el-dropdown style="margin-left:5px;margin-top:-2px"  >
                <el-button type="primary" size="mini" style="height:32px; ">
                    更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item> 
                        <el-link  @click="impExcel" :underline="false" >
                            <i class="iconfont icon-xiazai" style="font-size:16px;  color:#409eff; "></i>
                            <span style="font-size:12px;  font-weight:600;margin-left:5px;">导入csv</span>
                        </el-link>
                    </el-dropdown-item>
                    <el-dropdown-item divided> 
                        <el-link  @click="expExcel" :underline="false"  >
                            <i class="iconfont icon-daochu1" style="font-size:16px; color:#409eff; "></i>
                            <span style="font-size:12px;  font-weight:600;margin-left:5px;">导出EXCEL</span>
                        </el-link>
                    </el-dropdown-item>
                    <el-dropdown-item divided> 
                        <el-link  @click="delData" :underline="false"  >
                            <i class="iconfont icon-shanchu1" style="font-size:16px;  color:#409eff; "></i>
                            <span style="font-size:12px;  font-weight:600;margin-left:5px;">删除数据</span>
                        </el-link>
                    </el-dropdown-item>
 
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <el-table  :data="tabData" 
                    border         
                    class="custom-table-border"                   
                    disabled-hover
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :cell-style="{padding:'2px'}"
                    :height="tabHeight" 
                    :row-key="getRowKey"  
                    ref="tabref" 
                    highlight-current-row>
            <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="left"                                  
                :sortable="item.key!=='RN'&& item.edcss!=='checkbox'"
                :min-width="item.width">
                <template   slot-scope="scope" >
                    <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" ></el-checkbox>
                    <el-link v-else-if="item.key=='ORDNO'" :underline="false" @click="editRec(scope.row, scope.$index)"  >
                        <span v-text="scope.row[item.key]" style="border-bottom:1px solid blue;color:#409eff"> </span>
                    </el-link>
                    <span v-else v-text="scope.row[item.key]"  ></span>
                </template>
            </el-table-column>                    
        </el-table>
        <div style="margin-top:5px; overflow: hidden;display:flex;background:white;font-size:12px;line-height:30px;height:35px">
            <div style="float: left;padding-left:5px">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
 
            <div style="color:#606266;margin-right:5px; margin-left:10px;font-size:12px;width:30px;">跳至</div>
            <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
            <span style="color:#606266;margin-left:5px;font-size:12px;">页</span>
            <el-button @click="goNext" size="small" type="primary" style="width:50px;margin-left:15px;height:32px;">GO</el-button>
        </div> 
        <!-- 删除资料-->
        <el-dialog :visible.sync="delWin" v-dialogDrag width="530px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">删除店铺数据</span>
            </div> 
            <span >请选择店铺</span>
            <el-select  v-model="shopno"  style="width:100%" filterable placeholder="请选择">
                <el-option v-for="it  in  shopArr " :key="it.IDSEQ"  :value="it.CODE" :label="it.CNAME" ></el-option>
            </el-select> 
            <span >开始交易日期</span>
            <el-date-picker :clearable="false" :editable="false"  type="date"  v-model="frdttm" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
            <span >结束交易日期</span>
            <el-date-picker :clearable="false" :editable="false"  type="date"  v-model="todttm" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:15px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="delWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="delSure" style="margin-right:10px;">确定</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 导入csv-->
        <el-dialog :visible.sync="impWin" v-dialogDrag width="530px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">导入csv文件</span>
            </div> 
            <span >请选择店铺</span>
            <el-select  v-model="shopid"  style="width:100%" filterable placeholder="请选择">
                <el-option v-for=" it  in  shopArr " :key="it.IDSEQ"  :value="it.CODE+'-'+it.SUBNO" :label="it.CNAME" ></el-option>
            </el-select> 
            <div style=" display:flex">
                <Upload
                    ref="upload"
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeTxtFile"
                    :on-success="successTxtFile"
                    :on-progress="handleProgress"
                    :with-credentials="true"                       
                    :format="['csv' ]"
                    :max-size="4096"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :action="uploadUrl"
                    style="display: inline-block;width:90px;text-align:left ">                           
                        <el-link :underline="false" style="padding: 1px 0;width:120px;height:120px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"  ></el-image> 
                        </el-link>                                                      
                </Upload>
                <div style="display:flex;flex-direction:column" >
                    <div style="line-height:55px;display:flex">
                        <div style="color:#483D8B;font-weight:600;font-size:12px;text-align:right;width:105px;margin-right:14px; ">文件路径</div>
                        <el-input size="small"  disabled v-model="txtPath" placeholder="显示项"  style="width:300px; " ></el-input>
                    </div>
                    <div style="line-height:55px;display:flex">
                        <div style="color:#483D8B;font-weight:600;font-size:12px;text-align:right;width:105px;margin-right:14px; ">文件名</div>
                        <el-input size="small"  disabled v-model="fileNm" placeholder="显示项"  style="width:300px; " ></el-input>
                    </div>
                    <div style="line-height:55px;display:flex">
                        <div style="color:#483D8B;font-weight:600;font-size:12px;text-align:right;width:105px;margin-right:14px; ">文档记录行数</div>
                        <el-input size="small"  disabled v-model="txtNum" placeholder="显示项"  style="width:300px; " ></el-input>
                    </div>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:15px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="impWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-baocun"  @click="csvSure" style="margin-right:10px;">确定</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog :visible.sync="promptWin" v-dialogDrag width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="addWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:89vh;overflow-y:auto">
            <Form ref="addForm" :model="formCol" :label-width="120"    label-position="right" inline >
                <span v-for="(item,index) in tabArr" :key="index" >
                    <FormItem :class="item.key=='SKUDESC'?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        
                        <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-input  type="textarea" :rows="3"  v-else-if="item.key==='SKUDESC'"   v-model="formCol[item.key]"></el-input> 
                        <el-input :placeholder="item.holder" type="text" v-else :disabled="item.disabled=='Y'"  v-model="formCol[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>   
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:5px;">取消</el-button>
                </span>
            </div>
        </el-dialog>
    </div>
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate} from '../../api/Select'  
//局部注册
export default {
    name:"manage_Summary",
    data () {
        return {   
            delWin:false,
            frdttm:'',
            todttm:'',
            shopno:'',
            loadWin:false,
            formCol:{},
            txtPath:'',
            txtNum:'',
            fileNm:'',
            videoUploadPercent:0, 
            videoFlag:false,
            shopid:'',  
            impWin:false,     
            promptWin:false,
            prompt:'',
            operArr:[],
            allData:[],
            tabArr:[], //表列   
            tabData:[],  
            shopArr:[],  
            oper:'like',
            txtparam:'',
            selparam:'SHOPNM',  
            oper2:'like',
            txtparam2:'',
            selparam2:'',   
            oper3:'like',
            txtparam3:'',
            selparam3:'', 
            addWin:false,
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_bsurl:'xuper_auth/getTableRecMany'  ,       
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            Accept: 'csv', //上传文件格式限制
            uploadData:{} , 
            uploadUrl:'xuper_auth/readTxt' ,
            dataCount:0,
            rowSize:50,
            goPage:'', 
            current:1,
            pageList: [ {
                value: 40,
                label: '40'
                }, {
                value: 100,
                label: '100'
                }, {
                value: 200,
                label: '200'
            }],
        }
    },
    mounted () { 
        //操作符
        getBaseData(this.v_bsurl,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        //店铺
        getBaseData(this.v_bsurl,'PARENTNO','22363','','','v_sys_base','').then(res=>{
            this.shopArr =res.result
        })
        this.getFocus()       
    },
    computed: {
        dlgWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 200) + 'px';
        }, 
    },
    components: {
     
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.getShopList(' and rownum<='+this.rowSize)
            this.getTabField() //表列字段
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        getFocus(){
            this.$nextTick(()=>{
                this.$refs['refinput'].focus()
            })
        },
        //删除店铺数据
        delSure(){
            if (!this.shopno){
                this.promptWin=true
                this.prompt ='请选择店铺'
            }else if (!this.frdttm){
                this.promptWin=true
                this.prompt ='请选择开始日期'
            }else if (!this.todttm){
                this.promptWin=true
                this.prompt ='请选择结束日期'
            }else{
                this.$confirm('你确定要删除数据吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'SHOPID',p_value:this.shopno,p_key2:'corpid',p_value2:this.v_corpid,p_table:'V_AMZ_DELSUM',p_cond:' and dttm>=\''+this.frdttm+'\' and dttm<=\''+this.todttm+'\''},
                    }).then(res=>{ 
                        this.delWin =false       
                        this.getShopList(' and rownum<='+this.rowSize)   
                    }) 
                    
                }).catch(()=>{})               
            }
        },
        delData(){
            this.delWin =true
            this.shopno=''
            this.frdttm=''
            this.todttm=''
        },
        impText(){
            this.impWin =true
            this.txtPath=''
            this.txtNum=''
            this.fileNm=''
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择 csv'
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出4M' 
        },
        // 文件上传成功时的钩子
        successTxtFile(res,file){
            this.videoUploadPercent=0  
            this.videoFlag=false   
            this.txtPath=res.result
            this.txtNum=res.rowcnt
            this.fileNm=file.name;            
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeTxtFile (res, file) {    
            this.fileName= this.v_username+getDate('year')
            this.uploadData = {
                p_code: this.fileName ,
                p_corpid:this.v_corpid,
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        impExcel(){
            this.impWin =true
            this.shopid=''
            this.txtPath=''
            this.txtNum=''
            this.fileNm=''
        },
        //导入CSV
        csvSure(){
            let num =this.shopid.indexOf('-') ,v_shopid=this.shopid.substring(0,num),v_area=this.shopid.substring(num+1)
            let vm =this
            if (!this.shopid){
                this.promptWin=true
                this.prompt ='请选择店铺'
            }else{
                if (this.fileNm){
                    let v_url =''
                    if (v_area =='CAND' ){  //Zenyoyo-加拿大 ,要少一列
                        v_url ='xuper_auth/candaCvs'
                    }else if (v_area =='GER' ){  //德国 ,要少三列
                        v_url ='xuper_auth/germanCvs'
                    }else{  //美国
                        v_url ='xuper_auth/saveTxt'
                    }
                    this.$confirm('你确定要导入此文件吗？','提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        this.loadWin=true
                        this.impWin =false
                        this.$axios({
                            method: 'post',
                            url: v_url,
                            data: {p_path:this.txtPath,corpid:this.v_corpid,code:v_shopid ,p_user:this.v_username},
                        }).then(res=>{        
                            if(res.code =='200')  {
                                this.loadWin =false
                                this.getShopList(' and rownum<='+this.rowSize)   
                            }else{
                                this.loadWin =false
                                this.promptWin=true
                                this.prompt ='导入错误，文件格式与选择国家店铺不匹配，请核查！'
                            }     
                        }) 
                        
                    }).catch(()=>{})
                }else{
                    this.promptWin=true
                    this.prompt='文件名不能为空'
                }
                
            }
        },
        editRec(row,index){
            this.addWin =true
            this.formCol =JSON.parse(JSON.stringify(row))
        },
        //导出
        expExcel(){
            let cond_=[]
            cond_.push(this.selparam)
            cond_.push(this.oper)
            cond_.push(this.txtparam)
            cond_.push(this.selparam2)
            cond_.push(this.oper2)
            cond_.push(this.txtparam2)
 
            let url='xuper_auth/report/ExpExcel'+'&p_key=corpid&p_value='+this.v_corpid+'&p_idseq=22371&p_lstseq=1&p_table=V_AMZ_SUM&p_cond='+cond_+'&p_filenm=亚马逊经营汇总表'
            window.open(url)
        },
        //店铺经营明细
        getShopList(cond){
            let  cond_=''
            if (this.selparam && this.txtparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and upper('+this.selparam+') like upper(\'%' + this.txtparam+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam+')' +this.oper+'upper(\''+this.txtparam+'\')'
                }
            }
            if (this.selparam2 && this.txtparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and upper('+this.selparam2+') like upper(\'%' + this.txtparam2+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam2+')' +this.oper2+'upper(\''+this.txtparam2+'\')'
                }
            } 
            if (this.selparam3 && this.txtparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and upper('+this.selparam3+') like upper(\'%' + this.txtparam3+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam3+')' +this.oper3+'upper(\''+this.txtparam3+'\')'
                }
            } 
            //获取所有产品记录且初始化分页记录    
            this.loadWin=true 
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond ,p_table:'V_AMZ_SUM'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData =res.result
 
                    getTabColOrData('xuper_auth/getRecordCnt','v_AMZ_SUM','corpid',this.v_corpid,'','','','',cond_).then((res) => {
                        console.log('count:'+res.result+':'+cond_)
                        this.dataCount =res.result
                    })
                    this.loadWin=false                   
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs['tabref'].doLayout();
                    this.current =Number(1)
                })
            }) 
        },
        //分页查询
        getPageList(cond,index){
            let  cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and upper('+this.selparam+') like upper(\'%' + this.txtparam+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam+')' +this.oper+'upper(\''+this.txtparam+'\')'
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and upper('+this.selparam2+') like upper(\'%' + this.txtparam2+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam2+')' +this.oper2+'upper(\''+this.txtparam2+'\')'
                }
            }  
            if (this.selparam3 && this.txtparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and upper('+this.selparam3+') like upper(\'%' + this.txtparam3+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam3+')' +this.oper3+'upper(\''+this.txtparam3+'\')'
                }
            } 
            //获取所有产品记录且初始化分页记录    
            this.loadWin=true 
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond_+cond ,p_table:'V_AMZ_SUM'},
            }).then(res=>{ 
                if (res.code==='200'){
                    var _start = ( index - 1 ) * this.rowSize;
                    var _end = index * this.rowSize;
                    this.tabData = res.result.slice(_start,_end);
                    this.loadWin=false
                } 
            }) 
        },
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promptWin=true
                this.prompt='请输入跳至页数'
            }
        },
 
        //表格页面导航
        changePage(index){
            //var _start = ( index - 1 ) * this.rowSize;
            //var _end = index * this.rowSize;
            this.getPageList(' and rownum<='+this.rowSize*index,index)
            //this.tabData = this.allData.slice(_start,_end);
        },
  
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and upper('+this.selparam+') like upper(\'%' + this.txtparam+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam+')' +this.oper+'upper(\''+this.txtparam+'\')'
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and upper('+this.selparam2+') like upper(\'%' + this.txtparam2+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam2+')' +this.oper2+'upper(\''+this.txtparam2+'\')'
                }
            }  
            if (this.selparam3 && this.txtparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and upper('+this.selparam3+') like upper(\'%' + this.txtparam3+'%\')'
                }else{
                    cond_=cond_+' and upper('+this.selparam3+')' +this.oper3+'upper(\''+this.txtparam3+'\')'
                }
            }       
            this.getShopList( cond_+' and rownum<='+this.rowSize)
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','22371','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .headbar{
        padding-left:5px; 
        line-height:40px;
        background:#fff;
        overflow: auto;
        padding-top:2px;
        display:flex;
        border-left:2px solid #409eff;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .item-width2  {
        width: 97%;
    } 
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 